interface PromoCodeWithoutCode {
  pathName?: string;
  promotionDays: number;
}

export interface PromoCode extends PromoCodeWithoutCode {
  promoCode: string;
}

export const promoCodes: PromoCode[] = [
  { promoCode: "boomer", pathName: "BOOMER30", promotionDays: 30 },
  { promoCode: "workingdraft", pathName: "workingdraft", promotionDays: 30 },
];

export const promoCodeWildcards: PromoCodeWithoutCode[] = [
  { pathName: "-promotion", promotionDays: 30 },
  { pathName: "-conference", promotionDays: 90 },
];

export const getPromoCodeFromPath = (): PromoCode | undefined => {
  const pathname = window.location.pathname.toLowerCase();

  for (const promoCode of promoCodes) {
    if (promoCode.pathName && pathname.includes(promoCode.pathName)) {
      return promoCode;
    }
  }

  for (const promoCodeWildcard of promoCodeWildcards) {
    if (
      promoCodeWildcard.pathName &&
      pathname.includes(promoCodeWildcard.pathName)
    ) {
      return {
        promoCode: pathname.split("lp/")[1] ?? pathname,
        ...promoCodeWildcard,
      };
    }
  }

  return undefined;
};
